import React from 'react';
import { withTranslation, WithTranslation } from 'react-i18next';
import { Url } from '@wix/da-url';
import {
  withVerification,
  WithVerificationProps,
} from '@wix/da-shared-react/pkg/VerificationPopup/withVerification';
import EmptyState from '../../../../EmptyState';

export interface Props {
  view?: 'wide' | 'large';
  total: number;
  username: string;
  isOwner: boolean;
  enableAllCommissions(): void;
}

export class DisabledEmptyState extends React.Component<
  Props & WithTranslation & WithVerificationProps
> {
  render() {
    const {
      view = 'large',
      total,
      isOwner,
      username,
      enableAllCommissions,
      t,
    } = this.props;

    return (
      <EmptyState
        view={view}
        title={
          isOwner
            ? t!('pages.shop.disabledState.commissions.titleOwner')
            : t!('pages.shop.disabledState.commissions.title', { username })
        }
        subtitle={
          isOwner
            ? t!('pages.shop.disabledState.commissions.subtitleOwner', {
                count: total,
              })
            : t!('pages.shop.disabledState.commissions.subtitle')
        }
        buttonLabel={
          isOwner
            ? t!('pages.shop.disabledState.commissions.enableAllCommissions')
            : t!('pages.shop.disabledState.commissions.messageArtist')
        }
        onButtonClick={isOwner ? enableAllCommissions : this.navigateToNotes}
        withButton={true}
      />
    );
  }

  navigateToNotes = () => {
    const {
      username,
      isVerificationNeeded,
      pushVerificationPopup,
    } = this.props;
    if (isVerificationNeeded) {
      pushVerificationPopup('notes');
      return;
    }

    const notesPath = Url.userNoteLink(username);
    window.location.replace(notesPath);
  };
}

export default withVerification(
  withTranslation()(DisabledEmptyState)
) as React.ComponentType<Props>;
